import { Rule } from "antd/es/form";
import { useMemo } from "react";

export const useCredsRules = () => {
  const passwordRules: Rule[] = useMemo(
    () => [
      {
        required: true,
        validateTrigger: "onSubmit",
      },
      {
        max: 30,
        validateTrigger: "onSubmit",
      },
    ],
    [],
  );

  const usernameRules: Rule[] = useMemo(
    () => [
      {
        required: true,
        validateTrigger: "onSubmit",
      },
      {
        max: 100,
        validateTrigger: "onSubmit",
      },
    ],
    [],
  );

  return { passwordRules, usernameRules };
};
